/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.15.0
 */

import { useMemo } from 'react';

import { Step } from 'react-joyride';
import { useSelector } from 'react-redux';

import { makeSelectTariffsAndServicesIsFooterVisible } from '@/main/pages/PageProducts/tariffsAndServicesSelectors';

import { EOnboardingPage } from '../types/onboardingTypes';

export type IOnboardingPageConfiguration = Pick<Step, 'offset'> & { offsetBottom: number };

export const useOnboardingElementsConfiguration = () => {
    const isTariffsAndServicesFooterVisible = useSelector(makeSelectTariffsAndServicesIsFooterVisible());

    return useMemo<{ [key in EOnboardingPage]: IOnboardingPageConfiguration }>(() => {
        const config = {
            [EOnboardingPage.dashboard]: {
                offset: 100,
                offsetBottom: -10,
            },
            [EOnboardingPage.accounts]: {
                offset: 200,
                offsetBottom: 0,
            },
            [EOnboardingPage.subscriberMobile]: {
                offset: 200,
                offsetBottom: 0,
            },
            [EOnboardingPage.expensesAnalyzerAccount]: {
                offset: 200,
                offsetBottom: 37,
            },
            [EOnboardingPage.products]: {
                offset: 250,
                offsetBottom: 64,
            },
            [EOnboardingPage.settings]: {
                offset: 200,
                offsetBottom: 33,
            },
            [EOnboardingPage.bills]: {
                offset: 200,
                offsetBottom: 37,
            },
            [EOnboardingPage.inquiries]: {
                offset: 200,
                offsetBottom: 0,
            },
        };

        if (!isTariffsAndServicesFooterVisible) {
            config[EOnboardingPage.products].offsetBottom = 0;
        }

        return config;
    }, [isTariffsAndServicesFooterVisible]);
};
